import {ActionType} from "../model";
import {Client} from "../model/client";
import {setAlert, setErrorAlert} from "./alert";
import {isDebug} from "../utils/commonUtils";


const MainPathPrefix = 'giftor';
const SubPathPrefix = `${MainPathPrefix}/recipient`;

type AddGWTClientProps = (model: Client) => (dispatch: Function, store: Function, api: {
    post: Function
}) => Promise<any>;
export const addGWTClient: AddGWTClientProps = (model, message: boolean = true) => async (dispatch, _store, api) => {
    try {
        const response = await api.post(`${MainPathPrefix}/agent/client/gwt`, model);
        if (!message) {
            dispatch(setAlert("Invitation Sent Successfully.", 'success'));
        }
        return response
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type GWTAgentEmailsProps = (payload: any) => (dispatch: Function, store: Function, api: any) => Promise<any>;
export const triggerGWTAgentEmails: GWTAgentEmailsProps = (payload) => async (dispatch, _store, api) => {
    try {
        await api.post(`${MainPathPrefix}/agent/completion/emails`, payload);
        dispatch(setAlert("Invitation Sent Successfully.", 'success'));
        return;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type GiftorConfirmProps = (payload: any) => (dispatch: Function, store: Function, api: any) => Promise<any>;
export const onGiftorConfirm: GiftorConfirmProps = (payload) => async (dispatch, _store, api) => {
    try {
        const result = await api.put(`${MainPathPrefix}/confirm`, payload);
        dispatch({payload: result.data, type: ActionType.GIFTOR_CONFIRM});
        dispatch(setAlert(result.message, 'success'));
        return result;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type CreateChildRecipientProps = (payload: any) => (dispatch: Function, _store: Function, api: any) => Promise<any>;
export const createChildRecipient: CreateChildRecipientProps = (payload) => async (dispatch, _store, api) => {
    try {
        const result = await api.post(`${SubPathPrefix}`, payload);
        dispatch(setAlert(result.message, 'success'));
        return result
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type GetChildRecipientListProps = (queryParams: any) => (dispatch: Function, _store: Function, api: any) => Promise<any>;
export const getChildRecipientList: GetChildRecipientListProps = (queryParams) => async (dispatch, _store, api) => {
    try {
        const result = await api.get(`${SubPathPrefix}/list`, {}, queryParams || {});
        dispatch({payload: result, type: ActionType.FETCH_RECIPIENTS});
        return result;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type DeleteChildRecipientProps = (id: number) => (dispatch: Function, _store: Function, api: any) => Promise<any>;
export const deleteChildRecipient: DeleteChildRecipientProps = (id) => async (dispatch, _store, api) => {
    try {
        const result = await api.delete(`${SubPathPrefix}/${id}`);
        dispatch(setAlert('Recipient Deleted Successfully', 'success'));
        return result;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type GetChildRecipientProps = (id: number) => (dispatch: Function, _store: Function, api: any) => Promise<any>;
export const getChildRecipient: GetChildRecipientProps = (id) => async (dispatch, _store, api) => {
    try {
        const result = await api.get(`${SubPathPrefix}/${id}`);
        dispatch({payload: result, type: ActionType.GET_RECIPIENT_BY_ID});
        return result;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type GetChildRecipientByIdProps = (model: Client) => (dispatch: Function, _store: Function, api: {
    post: Function
}) => Promise<any>;
export const getRecipientDocusign: GetChildRecipientByIdProps = (model) => async (dispatch, _store, api) => {
    try {
        const res = await api.post(`${SubPathPrefix}/docusign`, model);
        isDebug() && console.info(res);
        return res;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type RecipientDocusignCompletionProps = () => (dispatch: Function, _store: Function, api: {
    post: Function
}) => Promise<any>;
export const onRecipientDocusignCompletion: RecipientDocusignCompletionProps = () => async (dispatch, _store, api) => {
    try {
        let response = await api.post(`${SubPathPrefix}/docusign/complete`, {}, {});
        dispatch(setAlert("Invitation sent successfully.", 'success'));
        return response;
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
};

type InviteAndEmailAfterDocApproveProps = (payload: {
    envelopeId: string
}) => (dispatch: Function, store: Function, api: { post: Function }) => Promise<any>;
export const inviteAndEmailAfterDocApprove: InviteAndEmailAfterDocApproveProps = (payload) => async (dispatch, _store, api) => {
    try {
        return api.post(`${SubPathPrefix}/admin-approved-invite-email`, payload);
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
}

type AdminApproveGiftorRecipientsDocusignProps = (envelopeId: string) => (dispatch: Function, getState: Function, api: any) => Promise<any>;
/**
 * Get the docusign by Envelope ID - Admin Action Items
 * @param envelopeId
 */
export const getAdminChildDocusign: AdminApproveGiftorRecipientsDocusignProps = (envelopeId) => async (dispatch, _store, api) => {
    try {
        return api.post(`${SubPathPrefix}/admin/approve/docusign`, {envelopeId});
    } catch (err) {
        return dispatch(setErrorAlert((err as any).message, (err as any).statusCode));
    }
}
